if (typeof BSS_B2B !== "undefined" && BSS_B2B) {
  setTimeout(() => {
    const observer = new MutationObserver((MutationList) => {
      for (let item of MutationList) {
        if (item.target?.offsetParent?.classList.contains("cart-sidebar")) {
          BSS_B2B.observer.cartSubject.listenCartCheckout();
        }
        if (item.target?.classList.contains("yv-header-searchbar-content")) {
          handleCartDrawerFooterMutation();
        }
        if (
          item.target?.lastElementChild?.classList.contains(
            "yv-quickview_product_wrapper"
          )
        ) {
          document.dispatchEvent(new Event(`bss_b2b:QuickviewLoaded`));
        }
      }
    });
    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  }, 300);
}

async function handleCartDrawerFooterMutation() {
  if (BSS_B2B) {
    const res = await BSS_B2B.storage.productStorage.load();
    if (res) {
      if (
        res.notExistProductIds?.length ||
        res.productIds?.length ||
        res.variantIds?.size
      ) {
        BSS_B2B.observer.productSubject.notifyObserver(
          "LazyProduct",
          "LoadedLazyProduct",
          {
            ...res,
          }
        );
      }
    }
  }
}

// console.log("start")

// BSS_BCP.addAction('custom_show_r4q', function ({ applyCartPage, quoteConfig, translations, shopData }) {
//   console.log("test")
//   const quickViewObserver = new MutationObserver(function (mutations, observer) {
//     for (const mutation of mutations) {
//       if (mutation.type === "attributes" && mutation.attributeName === "class") {
//         applyCartPage(shopData, BSS_BCP, quoteConfig, translations);
//       }
//     }
//   });
//   quickViewObserver.observe(document.body, { attributes: true });
// });
  
